export const POLICY_NOT_FOUND = 'POLICY_NOT_FOUND'
export const POLICY_NOT_ISSUED = 'POLICY_NOT_ISSUED'
export const BAD_BAD_FIELD_INPUT = 'BAD_BAD_FIELD_INPUT'
